import create from 'zustand';
import { Position, Notification, Agent } from '../types';

// Define the store state type
type Store = {
  notifications: Notification[];
  agents: Agent[];
  addNotification: (notification: Omit<Notification, 'id'>) => void;
  removeNotification: (id: string) => void;
  updateAgentPosition: (id: string, position: Position) => void;
};

export const useLandingStore = create<Store>((set) => ({
  notifications: [],
  agents: [
    {
      id: '1',
      name: 'Alpha',
      role: 'Assistant',
      avatar: '/avatars/alpha.svg',
      position: { x: 20, y: 30 },
      status: 'active'
    },
    {
      id: '2',
      name: 'Beta',
      role: 'Analyst',
      avatar: '/avatars/beta.svg',
      position: { x: 40, y: 50 },
      status: 'idle'
    },
    {
      id: '3',
      name: 'Gamma',
      role: 'Campus Agent, please check us out at https://www.campusagents.ai',
      avatar: '/avatars/gamma.svg',
      position: { x: 40, y: 50 },
      status: 'idle'
    }
  ],
  addNotification: (notification) => 
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id: Date.now().toString() }]
    })),
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id)
    })),
  updateAgentPosition: (id, position) =>
    set((state) => ({
      agents: state.agents.map((agent) =>
        agent.id === id ? { ...agent, position } : agent
      )
    }))
})); 